import { useState, useMemo, useEffect } from "react";
import CalendarContext, { CalendarContextValue } from ".";
import { InputData } from "../model";
import { useDispatch } from "../../store/store";
import { initData } from "../../store/data";

interface Props {
    inputData: InputData;
    children: React.ReactNode;
}

const CalendarProvider = ({ children, inputData }: Props) => {
    const [isInitialised, setInitialized] = useState(false);

    const initialValue: CalendarContextValue = useMemo(
        () => ({
            profile: {
                doctorName: inputData.doctorName,
                doctorPic: inputData.doctorPic,
                id: inputData.doctorId,
            },
            calendarSettings: {
                calendarStart: inputData.calendarStart,
                calendarEnd: inputData.calendarEnd,
                intervalLength: inputData.intervalLength,
                withoutEditProfile: inputData.withoutEditProfile,
            },
            inputCallbacks: {
                onModifyProfile: inputData.onModifyProfile,
                onCancelReservation: inputData.onCancelReservation,
                onSaveCalendar: inputData.onSaveCalendar,
                onChangeConsultationButtonClick:
                    inputData.onChangeConsultationButtonClick,
                onChangeConsultationClose: inputData.onChangeConsultationClose,
                onStartEndTimeError: inputData.onStartEndTimeError,
                changeWithoutSave: inputData.changeWithoutSave,
            },
        }),
        [inputData]
    );

    const dispatch = useDispatch();

    // Initial loading from props to store
    useEffect(() => {
        dispatch(initData(inputData.calendarData));
        setInitialized(true);
    }, [dispatch, inputData.calendarData]);

    if (!isInitialised) {
        return null;
    }

    return (
        <CalendarContext.Provider value={initialValue}>
            {children}
        </CalendarContext.Provider>
    );
};

export default CalendarProvider;
